<div class="text-center flex flex-col items-center leading-relaxed gap-8">
  <div class="relative card-base lg:justify-center p-8 lg:p-16 gap-8">
    <h2 class="text-4xl font-bold font-brand">{{errorMessage ?? ""}}</h2>
    <button *ngIf="showsRetryButton" class="h-16 font-brand font-bold text-xl bg-primary-brand rounded-2xl">
      <a (click)="reloadPage()" class="p-16 text-white">Riprova</a>
    </button>
    <p>In caso di problemi, contatta il venditore.</p>
    <div class="low-band-absolute"></div>
  </div>
</div>